import React, { useEffect, useState, useMemo, useContext } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../../config/config";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
// import { event } from "jquery";
import moment from "moment";
import { AppContext } from "../../../context/AppContext";

const QuickbookSync = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  // const quickbookstatus= localStorage.getItem("QuickbookStatus")
  const {Label,UserRoles} = useContext(AppContext)
   console.log(UserRoles,"quickbookstatus==>")
  const loginuserid = localStorage.getItem("ID");
  const [label, setLabel] = useState(false);
 // const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });
  const [sorting, setSorting] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [responseData, setResponseData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  // const [loading, setLoading] = useState(false);
  const [showselectedsuccesscutomer, setshowselectedsuccesscutomer] =
    useState(true);
  const [showselectedfailcutomer, setshowselectedfailcutomer] = useState(false);
  const [btn, setbtn] = useState(1);
  const [detilesdata, setdetilesdata] = useState("");
  const [show, setshow] = useState(false);
  // const [btnid,setbtnid] = useState(1)

  const SuccesshandleChange = (event) => {
    console.log(event.target.checked, "SuccesshandleChange");
    setshowselectedsuccesscutomer(event.target.checked);
    setshowselectedfailcutomer(false);
  };

  const FailhandleChange = (event) => {
    console.log(event.target.checked, "handleChange");
    setshowselectedfailcutomer(event.target.checked);
    setshowselectedsuccesscutomer(false);
  };

  console.log(btn, "btn");
  const handleQuickbookSync = (field) => {
    const body = {
      loginuserid: loginuserid,
    };

    if (field == "Customer") {
      setLoading(true);
      axios
        .post(
          `${config.quickbooksBaseUrl}/quickbooks/batchupdatecustomerfaildata`,
          body,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setLoading(false);
          console.log("res======>", res.data);
        })

        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const handlechangeCustomer = (event) => {
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    if (btn === 1) {
      // if (showselectedsuccesscutomer) {
      //   axios
      //     .get(
      //       `${
      //         config.quickbooksBaseUrl
      //       }/quickbooks/quickbookidsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
      //         sorting[0]?.desc === undefined
      //           ? "desc"
      //           : sorting[0]?.desc === true
      //           ? "desc"
      //           : "asc"
      //       }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
      //         pagination.pageSize
      //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
      //         globalFilter === undefined ? "" : globalFilter
      //       }&startdate=${startdate}&enddate=${enddate}`,
      //       {
      //         headers: {
      //           "Content-Type": "application/json;charset=UTF-8",
      //           "Access-Control-Allow-Origin": "*",
      //           Authorization: token,
      //         },
      //       }
      //     )
      //     .then((res) => {
      //       console.log("res======>", res);
      //       console.log(res.data.ResponseData, "res======>");
      //       if (res.data.ResponseCode === "SUCCESS") {
      //         setResponseData(res.data.ResponseData);
      //         setData(res.data.ResponseData);
      //         setRowCount(res.data.ResponseData[0].TotalRecord);
      //         // setshowselectedsuccesscutomer(event.target.checked);
      //       }
      //     })

      //     .catch((err) => {
      //       setLoading(false);
      //       setResponseData([]);
      //     });
      // }

      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookidunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            console.log(err, "errorresponse");
            //setResponseData([]);
            // setData([]);
            setLoading(false);
          });
      }
    }

    console.log(responseData, "responsedata====>");

    if (btn === 2) {
      // if (showselectedsuccesscutomer) {
      //   axios
      //     .get(
      //       `${
      //         config.quickbooksBaseUrl
      //       }/quickbooks/quickbookvendorsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
      //         sorting[0]?.desc === undefined
      //           ? "desc"
      //           : sorting[0]?.desc === true
      //           ? "desc"
      //           : "asc"
      //       }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
      //         pagination.pageSize
      //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
      //         globalFilter === undefined ? "" : globalFilter
      //       }&startdate=${startdate}&enddate=${enddate}`,
      //       {
      //         headers: {
      //           "Content-Type": "application/json;charset=UTF-8",
      //           "Access-Control-Allow-Origin": "*",
      //           Authorization: token,
      //         },
      //       }
      //     )
      //     .then((res) => {
      //       console.log("res======>", res);
      //       console.log(res.data.ResponseData, "res======>");
      //       if (res.data.ResponseCode === "SUCCESS") {
      //         setResponseData(res.data.ResponseData);
      //         setData(res.data.ResponseData);
      //         setRowCount(res.data.ResponseData[0].TotalRecord);
      //         // setshowselectedsuccesscutomer(event.target.checked);
      //       }
      //     })

      //     .catch((err) => {
      //       setLoading(false);
      //     });
      // } else
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookvendorunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 3) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookitemunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 4) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbooksaleunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}&salestype=${1}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 11) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbooksaleunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}&salestype=${2}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 12) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbooksaleunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}&salestype=${3}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 5) {
      // if (showselectedsuccesscutomer) {
      //   axios
      //     .get(
      //       `${
      //         config.quickbooksBaseUrl
      //       }/quickbooks/quickbookcategoriessuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
      //         sorting[0]?.desc === undefined
      //           ? "desc"
      //           : sorting[0]?.desc === true
      //           ? "desc"
      //           : "asc"
      //       }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
      //         pagination.pageSize
      //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
      //         globalFilter === undefined ? "" : globalFilter
      //       }&startdate=${startdate}&enddate=${enddate}`,
      //       {
      //         headers: {
      //           "Content-Type": "application/json;charset=UTF-8",
      //           "Access-Control-Allow-Origin": "*",
      //           Authorization: token,
      //         },
      //       }
      //     )
      //     .then((res) => {
      //       console.log("res======>", res);
      //       console.log(res.data.ResponseData, "res======>");
      //       if (res.data.ResponseCode === "SUCCESS") {
      //         setResponseData(res.data.ResponseData);
      //         setData(res.data.ResponseData);
      //         setRowCount(res.data.ResponseData[0].TotalRecord);
      //         // setshowselectedsuccesscutomer(event.target.checked);
      //       }else {
      //         setResponseData([]);
      //       }
      //     })

      //     .catch((err) => {
      //       setLoading(false);
      //     });
      // } else
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookcategoriesunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 6) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookreceivingsunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}&ReceivingType=${1}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 13) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookreceivingsunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}&ReceivingType=${2}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }
    if (btn === 14) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookreceivingsunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}&ReceivingType=${3}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 15) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookreceivingsunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}&ReceivingType=${5}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }
    if (btn === 16) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookreceivingsunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}&ReceivingType=${6}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 7) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookemployeessunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 8) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookBankDepositHistoryunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 9) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookBankTransferunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 10) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookjournalEntryunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 17) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbookPaybillsunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setLoading(false);
          });
      }
    }

    if (btn === 18) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/quickbooksalespaymentssunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setResponseData([]);
            setLoading(false);
          });
      }
    }

    if (btn === 19) {
      if (!showselectedfailcutomer) {
        setLoading(true);
        axios
          .get(
            `${
              config.quickbooksBaseUrl
            }/quickbooks/onfleetsaleunsuccess?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
              sorting[0]?.desc === undefined
                ? "desc"
                : sorting[0]?.desc === true
                ? "desc"
                : "asc"
            }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
              pagination.pageSize
            }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
              globalFilter === undefined ? "" : globalFilter
            }&startdate=${startdate}&enddate=${enddate}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            console.log("res======>", res);
            console.log(res.data.ResponseData, "res======>");
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setData(res.data.ResponseData);
              setRowCount(res.data.ResponseData[0].TotalRecord);
              // setshowselectedfailcutomer(event.target.checked);
            } else {
              setResponseData([]);
            }
          })

          .catch((err) => {
            setResponseData([]);
            setLoading(false);
          });
      }
    }
  };

  // useEffect(()=>{
  //     axios.get(
  //         `http://localhost:3003/gettoken`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             "Access-Control-Allow-Origin": "*",
  //           },
  //         }
  //     )

  //     .then((res)=>{
  //         console.log(res.data)
  //     })
  //     .catch((err)=>{
  //         console.log(err)
  //     })

  // },[])

  useEffect(() => {
    // fetchData();

    const timer = setTimeout(() => {
      if (label) {
        // Make your API call here
        setshow(true);
      }
    }, 100); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [label]);

  useEffect(() => {
    axios
      .get(
        `${config.quickbooksBaseUrl}/quickbooks/gettoken?loginuserid=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )

      .then((res) => {
        // alert(JSON.stringify(res.data))
        const data = res.data.ResponseData[0];
        if (data.Isconnected == 1) {
          setLabel(true);
          // localStorage.setItem("QuickbookStatus",true)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // var authConfig = {
  //     clientId: config.clientId,
  //     clientSecret: config.clientSecret,
  //     redirectUri: config.redirectUri
  //     }

  //  const  intuitAuth = new OAuthProvider(authConfig)

  // const setScopes=(flowName)=>{
  //     authConfig.scopes = config.scopes[flowName]
  //     intuitAuth()
  // }

  // const generateAntiForgery = (session)=> {
  //     session.secret = csrf.secretSync()
  //     return csrf.create(session.secret)
  //   }

  // const handledata = (id) => {
  //   setStatement(false);
  //   setCustomer(false);
  //   setPayment(false);
  //   setListingData(true);
  //   setListId(id);
  //   setComment(false);
  //   setInternalNotes(false);
  // };

  useEffect(() => {
    handlechangeCustomer();
  }, [
    showselectedfailcutomer,
    btn,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    columnFilters,
    globalFilter,
  ]);

  const signtoquickbooks = (path) => {
    var win;
    var parameters = `location=1,width=800,height=650`;
    parameters +=
      ",left=" +
      (window.innerWidth - 800) / 2 +
      ",top=" +
      (window.innerHeight - 650) / 2;

    // Launch Popup
    win = window.open(path, "connectPopup", parameters);
    var timer = setInterval(function () {
      if (win.closed) {
        clearInterval(timer);
        axios
          .get(
            `${config.quickbooksBaseUrl}/quickbooks/gettoken?loginuserid=${loginuserid}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
              },
            }
          )

          .then((res) => {
            // alert(JSON.stringify(res.data))
            const data = res.data.ResponseData[0];
            if (data.Isconnected == 1) {
              setLabel(true);
              // localStorage.setItem("QuickbookStatus",true)
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }, 1000);
  };

  const handleotherroles = () => {
console.log(1,"oterroles");
setLoading(true)
axios.post(`${config.quickbooksBaseUrl}/quickbooks/tokenupsert`,{loginuserid:loginuserid},
  {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    },
  }
)
.then(res => {
console.log(res.data.ResponseCode == "SUCCESS","410501");
setLoading(false)
if(res.data.ResponseCode == "SUCCESS"){

  window.location.reload();
}

})
.catch(err => {
  setLoading(false)
  console.log(err);
  
})

  }

  let columns;

  // btn ===3 ?
  // (columns = [

  //   {
  //     header: "Id",
  //     accessorKey: "EntityId",
  //   },
  //   {
  //     header:"ItemName",
  //     accessorKey: "Name",
  //   },
  //   {
  //     header: "Message",
  //     accessorKey: "Message",
  //     size: 350,
  //   },
  //   {
  //     header: "CreatedDate",
  //     accessorKey: "CreatedDate",
  //     Cell: ({ row }) => {
  //       const Date = moment(row.original.CreatedDate);
  //       if (Date.isValid()) {
  //         return Date.format("MM/DD/YYYY h:mm A ");
  //       } else {
  //         return "";
  //       }
  //     },
  //   },
  //   {
  //     header: "Modified Date",
  //     accessorKey: "ModifiedDate",
  //     Cell: ({ row }) => {
  //       const ModifiedDate = moment(row.original.ModifiedDate);
  //       if (ModifiedDate.isValid()) {
  //         return ModifiedDate.format("MM/DD/YYYY h:mm A ");
  //       } else {
  //         return "";
  //       }
  //     },
  //   },

  // ]):
  btn === 18 
  ? (columns = [
      {
        header: "Id",
        accessorKey: "EntityId",
      },
      {
        header: "Customer Name",
        accessorKey: "Companyname",
        Cell: ({ row }) => (
          <p className="word-break-data">
            {row?.original?.Companyname}
          </p>
        ),
       
      },
      {
        header: "Message",
        accessorKey: "Message",
        size: 350,
        Cell: ({ row }) => (
          <p className="word-break-data">
            {row?.original?.Message}
          </p>
        ),
      },
      {
        header: "CreatedDate",
        accessorKey: "CreatedDate",
        // Cell: ({ row }) => {
        //   const Date = moment(row.original.CreatedDate);
        //   if (Date.isValid()) {
        //     return Date.format("MM/DD/YYYY h:mm A HH:mm:ss");
        //   } else {
        //     return "";
        //   }
        // },
      },
      {
        header: "Modified Date",
        accessorKey: "ModifiedDate",
        // Cell: ({ row }) => {
        //   const ModifiedDate = moment(row.original.ModifiedDate);
        //   if (ModifiedDate.isValid()) {
        //     return ModifiedDate.format("MM/DD/YYYY h:mm A HH:mm:ss ");
        //   } else {
        //     return "";
        //   }
        // },
      },
    ])
  :
  btn === 17
    ? (columns = [
        {
          header: "Id",
          accessorKey: "EntityId",
        },
        {
          header: "Supplier Name",
          accessorKey: "Companyname",
          Cell: ({ row }) => (
            <p className="word-break-data">
              {row?.original?.Companyname}
            </p>
          ),
         
        },
        {
          header: "Message",
          accessorKey: "Message",
          size: 350,
          Cell: ({ row }) => (
            <p className="word-break-data">
              {row?.original?.Message}
            </p>
          ),
        },
        {
          header: "CreatedDate",
          accessorKey: "CreatedDate",
          // Cell: ({ row }) => {
          //   const Date = moment(row.original.CreatedDate);
          //   if (Date.isValid()) {
          //     return Date.format("MM/DD/YYYY h:mm A ");
          //   } else {
          //     return "";
          //   }
          // },
        },
        {
          header: "Modified Date",
          accessorKey: "ModifiedDate",
          // Cell: ({ row }) => {
          //   const ModifiedDate = moment(row.original.ModifiedDate);
          //   if (ModifiedDate.isValid()) {
          //     return ModifiedDate.format("MM/DD/YYYY h:mm A ");
          //   } else {
          //     return "";
          //   }
          // },
        },
      ])
    : btn === 4 || btn === 11 || btn === 12
    ? (columns = [
        {
          header: "Id",
          accessorKey: "EntityId",
        },
        {
          header:
            btn === 2
              ? "Supplier Name"
              : btn === 3
              ? "Item Name"
              : btn === 5
              ? "Categories Name"
              : btn === 7
              ? "User Name"
              : btn === 8
              ? "Account Name"
              : btn === 9
              ? "Account To"
              : btn === 10
              ? "Credit Amount"
              : btn === 6
              ? "Supplier Name"
              : btn === 13
              ? "Supplier Name"
              : "Company Name",
          accessorKey: btn === 10 ? "Creditamt" : "CompanyName",
          Cell: ({ row }) => (
            <p className="word-break-data">
              {btn === 10 ? row?.original?.Creditamt : row?.original?.CompanyName}
            </p>
          ),
        },
        {
          header: "Message",
          accessorKey: "Message",
          size: 350,
          Cell: ({ row }) => (
            <p className="word-break-data">
              {row?.original?.Message}
            </p>
          ),
        },
        {
          header: "CreatedDate",
          accessorKey: "CreatedDate",
          // Cell: ({ row }) => {
          //   const Date = moment(row.original.CreatedDate);
          //   if (Date.isValid()) {
          //     return Date.format("MM/DD/YYYY h:mm A HH:mm:ss ");
          //   } else {
          //     return "";
          //   }
          // },
        },
        {
          header: "Modified Date",
          accessorKey: "ModifiedDate",
          // Cell: ({ row }) => {
          //   const ModifiedDate = moment(row.original.ModifiedDate);
          //   if (ModifiedDate.isValid()) {
          //     return ModifiedDate.format("MM/DD/YYYY h:mm A HH:mm:ss");
          //   } else {
          //     return "";
          //   }
          // },
        },
      ])
    : btn === 6 || btn === 13 || btn === 14 || btn === 15 || btn === 16
    ? (columns = [
        {
          header: "Id",
          accessorKey: "EntityId",
        },
        {
          header:
            btn === 2
              ? "Supplier Name"
              : btn === 3
              ? "Item Name"
              : btn === 5
              ? "Categories Name"
              : btn === 7
              ? "User Name"
              : btn === 8
              ? "Account Name"
              : btn === 9
              ? "Account To"
              : btn === 10
              ? "Credit Amount"
              : btn === 6
              ? "Supplier Name"
              : btn === 13
              ? "Supplier Name"
              : "Company Name",
          accessorKey: btn === 10 ? "Creditamt" : "CompanyName",
          Cell: ({ row }) => (
            <p className="word-break-data">
              {btn === 10 ? row?.original?.Creditamt : row?.original?.CompanyName}
            </p>
          ),
        },
        {
          header: "Message",
          accessorKey: "Message",
          size: 350,
          Cell: ({ row }) => (
            <p className="word-break-data">
              {row?.original?.Message}
            </p>
          ),
        },
        {
          header: "CreatedDate",
          accessorKey: "CreatedDate",
          // Cell: ({ row }) => {
          //   const Date = moment(row.original.CreatedDate);
          //   if (Date.isValid()) {
          //     return Date.format("MM/DD/YYYY h:mm A HH:mm:ss ");
          //   } else {
          //     return "";
          //   }
          // },
        },
        {
          header: "Modified Date",
          accessorKey: "ModifiedDate",
          // Cell: ({ row }) => {
          //   const ModifiedDate = moment(row.original.ModifiedDate);
          //   if (ModifiedDate.isValid()) {
          //     return ModifiedDate.format("MM/DD/YYYY h:mm A HH:mm:ss");
          //   } else {
          //     return "";
          //   }
          // },
        },
      ])
    : btn === 4 || btn === 9 || btn === 10
    ? (columns = [
        {
          header: "Id",
          accessorKey: "EntityId",
        },
        {
          header:
            btn === 6
              ? "Receiving Type"
              : btn === 9
              ? "Account From"
              : btn === 10
              ? "Debit Amount"
              : "",
          accessorKey: btn === 10 ? "debitamt" : "saletype",
        },
        {
          header:
            btn === 2
              ? "Supplier Name"
              : btn === 3
              ? "Item Name"
              : btn === 5
              ? "Categories Name"
              : btn === 7
              ? "User Name"
              : btn === 8
              ? "Account Name"
              : btn === 9
              ? "Account To"
              : btn === 10
              ? "Credit Amount"
              : btn === 6
              ? "Supplier Name"
              : btn === 13
              ? "Supplier Name"
              : "Company Name",
          accessorKey: btn === 10 ? "Creditamt" : "CompanyName",
          Cell: ({ row }) => (
            <p className="word-break-data">
              {btn === 10 ? row?.original?.Creditamt : row?.original?.CompanyName}
            </p>
          ),
        },
        {
          header: "Message",
          accessorKey: "Message",
          size: 350,
          Cell: ({ row }) => (
            <p className="word-break-data">
              {row?.original?.Message}
            </p>
          ),
        },
        {
          header: "CreatedDate",
          accessorKey: "CreatedDate",
          // Cell: ({ row }) => {
          //   const Date = moment(row.original.CreatedDate);
          //   if (Date.isValid()) {
          //     return Date.format("MM/DD/YYYY h:mm A HH:mm:ss");
          //   } else {
          //     return "";
          //   }
          // },
        },
        {
          header: "Modified Date",
          accessorKey: "ModifiedDate",
          // Cell: ({ row }) => {
          //   const ModifiedDate = moment(row.original.ModifiedDate);
          //   if (ModifiedDate.isValid()) {
          //     return ModifiedDate.format("MM/DD/YYYY h:mm A HH:mm:ss");
          //   } else {
          //     return "";
          //   }
          // },
        },
      ])
    : (columns = [
        {
          header: "Id",
          accessorKey: "EntityId",
        },
        {
          header:
            btn === 2
              ? "Supplier Name"
              : btn === 3
              ? "Item Name"
              : btn === 4
              ? "Company Name"
              : btn === 5
              ? "Categories Name"
              : btn === 7
              ? "User Name"
              : btn === 8
              ? "Account Name"
              : btn === 10
              ? "Credit Amount"
              : "Company Name",
          accessorKey: "CompanyName",
          Cell: ({ row }) => (
            <p className="word-break-data">
              {row?.original?.CompanyName}
            </p>
          ),
        },
        {
          header: "Message",
          accessorKey: "Message",
          size: 350,
          Cell: ({ row }) => (
            <p className="word-break-data">
              {row?.original?.Message}
            </p>
          ),
        },
        {
          header: "CreatedDate",
          accessorKey: "CreatedDate",
          // Cell: ({ row }) => {
          //   const Date = moment(row.original.CreatedDate);
          //   if (Date.isValid()) {
          //     return Date.format("MM/DD/YYYY h:mm A "); //HH:mm:ss 
          //   } else {
          //     return "";
          //   }
          // },
        },
        {
          header: "Modified Date",
          accessorKey: "ModifiedDate",
          // Cell: ({ row }) => {
          //   const ModifiedDate = moment(row.original.ModifiedDate);
          //   if (ModifiedDate.isValid()) {
          //     return ModifiedDate.format("MM/DD/YYYY h:mm A"); //HH:mm:ss
          //   } else {
          //     return "";
          //   }
          // },
        },
      ]);

  console.log(columns, "columnsdata==> ");
  // btn === 1 ? setdetilesdata("Customer Details") :
  // btn === 2 ? setdetilesdata("Supplier Details") : "";
  console.log(label, "label===>");

  return (
    <div>
      <Loader loading={loading} />
      <Sidebar />

      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {show ? (
            <label
              style={{ color: label ? "green" : "red", fontWeight: "bold" }}
            >
              {label
                ? "You are Successfully Connected to Quickbooks "
                : "You are Not Connected to Quickbooks "}
            </label>
          ) : (
            ""
          )}
          <br />

          {/* <button disabled={label==true} style={{width: "20%", height: "60px",fontSize: "20px", backgroundColor: "green", color: "white",marginTop: "9px"}}
       onClick={()=>signtoquickbooks(`${config.quickbooksBaseUrl}/quickbooks/sign_in_with_intuit?lu=${loginuserid}`)}>
        
           Connect To Quickbooks
       </button> */}
          <button
            //disabled={label == true}
            style={{
              width: "20%",
              height: "70px",
              fontSize: "20px",
              marginTop: "9px",
            }}
            onClick={() =>
              UserRoles == "SUPERADMIN" ? signtoquickbooks(
                `${config.quickbooksBaseUrl}/quickbooks/sign_in_with_intuit?lu=${loginuserid}`
              ) : handleotherroles()
            }
          >
            <img
              style={{ width: "100%", height: "100%" }}
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT67gZDYOPlvsHbvnUl4BvOG9IEqByK0cGow11lkfepcgsuWax29bAsRg5tHLDAFla6Xg&usqp=CAU"
              alt=""
            />
          </button>

          {/* <div className="row">
            <div className="col-md-11 z-3">
              <label className="col-form-label form-label p-lg-medium mr-3">
                <input
                  type="checkbox"
                  className="form-check-input mr-2"
                  style={{ width: "1.25em", height: "1.25em" }}
                  onChange={(event) => {
                    SuccesshandleChange(event);
                  }}
                  checked={showselectedsuccesscutomer}
                />
                Successful Data
              </label>

              <label className="col-form-label form-label p-lg-medium">
                <input
                  type="checkbox"
                  className="form-check-input mr-2"
                  style={{ width: "1.25em", height: "1.25em" }}
                  onChange={(event) => {
                    FailhandleChange(event);
                  }}
                  checked={showselectedfailcutomer}
                />
                Failed Data
              </label>
            </div>
          </div> */}

          {/* <div>
            <button
              className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3"
              role="tab"
              id="7"
            >
              {" "}
              <i class="fa fa-credit-card mr-2 mt-1"></i> Customer
            </button>
          </div> */}

          {/* <div>
            <button
              className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3"
              role="tab"
              id="8"
            >
              {" "}
              <i class="fa fa-credit-card mr-2 mt-1"></i> Customer
            </button>
          </div> */}
        </div>
      <div className="content container-fluid">
          <MaterialReactTable
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            columns={columns}
            data={responseData}
            // extraDropdownValue={showselectedcutomer}
            enableColumnResizing
            enableGrouping
            sortDescFirst
            enableStickyHeader
            enableStickyFooter
            // enableRowSelection
            enableColumnOrdering
            rowCount={rowCount}
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiPaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            manualFiltering
            manualPagination
            manualSorting
            // muiToolbarAlertBannerProps={
            //   isError
            //     ? {
            //         color: "error",
            //         children: "Error loading data",
            //       }
            //     : undefined
            // }
            muiTableBodyProps={{
              sx: () => ({
                "& tr:nth-of-type(even)": {
                  backgroundColor: "var(--datatable-row-background-color)",
                  //'rgb(237 237 233 / 63%)'
                },
                "& td": {
                  borderRight:
                    "1px solid var(--datatable-row-background-hover-color)",
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },

                "& tr": {
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },
              }),
            }}
            muiTableHeadCellProps={{
              sx: (theme) => ({
                background: "var(--datatable-row-background-color)", //'#e9e9e9',
                borderRight:
                  "1px solid var(--datatable-row-background-hover-color)",
                lineHeight: "16px",
                fontWeight: "500",
                fontSize: "14px",
                color: "var(--primary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            muiToolbarAlertBannerProps={
              // isError
              // ? {
              //   color: "error",
              //   children: "Error loading data",
              // }
              // : undefined
              {
                isError: () => ({
                  color: "error",
                  children: "Error loading data",
                }),
                sx: (theme) => ({
                  background: "var(--datatable-row-background-color)", //'#e9e9e9',
                  lineHeight: "16px",
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                }),
              }
            }
            muiSelectCheckboxProps={{
              sx: (theme) => ({
                lineHeight: "16px",
                fontWeight: "400",
                fontSize: "12px",
                color: "var(--prinary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            muiSelectAllCheckboxProps={{
              sx: (theme) => ({
                lineHeight: "16px",
                fontWeight: "400",
                fontSize: "12px",
                color: "var(--prinary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            // rowCount={rowCount}
            state={{
              columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <>
                {/* <Box
                  sx={{
                     display: "flex",
                    gap: "0.5rem",
                    p: "0.5rem",
                     flexWrap: "wrap",
                  }}
                >
                  <Box
                    sx={{
                     // display: "flex",
                      gap: "0.5rem",
                      p: "0.5rem",
                     // flexWrap: "wrap",
                    }}
                  >
                    <div>
        
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0" 
                        role="tab"
                        id="1"
                        onClick={() => handleQuickbookSync("Customer")}
                      >
                        <i className="fa fa-credit-card mr-2 mt-1"></i> Customer
                        Sync
                      </button>
                      <span className="mx-2 border-left border-secondary"></span>{" "}
                      {/* Added separator */}
                {/* </div>
                  </Box>

                  
                </Box> */}
                <Box
                  sx={{
                    display: "flex",
                    gap: "0.5rem",
                    p: "0.5rem",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <div className="row">
                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="1"
                        onClick={() => setbtn(1)}
                      >
                        {" "}
                        <i class="fas fa-user-alt mr-3 mt-1 "></i> Customer
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="2"
                        onClick={() => setbtn(2)}
                      >
                        {"|"}
                        <i class="fas fa-user-friends ml-3 mr-3 mt-1"></i>{" "}
                        Suppliers
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="3"
                        onClick={() => setbtn(3)}
                      >
                        {"|"}
                        <i class="fas fa-box-open ml-3 mr-3 mt-1"></i> Item
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="4"
                        onClick={() => setbtn(4)}
                      >
                        {"|"}
                        <i class="fa fa-shopping-bag ml-3 mr-3 mt-1"></i> Sale
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="4"
                        onClick={() => setbtn(11)}
                      >
                        {"|"}
                        <i class="fa fa-credit-card ml-3 mr-3 mt-1"></i>{" "}
                        Return/memo
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="4"
                        onClick={() => setbtn(12)}
                      >
                        {"|"}
                        <i class="fa fa-credit-card ml-3 mr-3 mt-1"></i>{" "}
                        Estimate
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="7"
                        onClick={() => setbtn(18)}
                      >
                        {"|"}
                        <i class="fa fa-credit-card ml-3 mr-3 mt-1"></i>{" "}
                        Receive Payment
                      </button>
                    </div>

                    {/* <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="5"
                        onClick={() => setbtn(5)}
                      >
                        {"|"}
                        <i class="fa fa-credit-card ml-3 mr-3 mt-1"></i>{" "}
                        Categories
                      </button>
                    </div> */}

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="6"
                        onClick={() => setbtn(6)}
                      >
                        {"|"}
                        <i class="fa fa-credit-card ml-3 mr-3 mt-1"></i>{" "}
                        Purchase Order
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="6"
                        onClick={() => setbtn(13)}
                      >
                        {"|"}
                        <i class="fa fa-shopping-cart ml-3 mr-3 mt-1"></i> Receive
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col-1-12 d-flex justify-content-end  mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="6"
                        onClick={() => setbtn(14)}
                      >
                        {"|"}
                        <i class="fas fa-user-friends  ml-3 mr-3 mt-1"></i>{" "}
                        Supplier Return
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="6"
                        onClick={() => setbtn(15)}
                      >
                        {"|"}
                        <i class="fas fa-user-friends ml-3 mr-3 mt-1"></i> Vendor
                        Credit
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="6"
                        onClick={() => setbtn(16)}
                      >
                        {"|"}
                        <i class="fas fa-money-check-alt ml-3 mr-3 mt-1"></i> Expense
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="7"
                        onClick={() => setbtn(17)}
                      >
                        {"|"}
                        <i class="fas fa-money-check-alt ml-3 mr-3 mt-1"></i>{" "}
                        PayBills
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="7"
                        onClick={() => setbtn(7)}
                      >
                        {"|"}
                        <i class="fas fa-user-tie ml-3 mr-3 mt-1"></i>{" "}
                        Employees
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="7"
                        onClick={() => setbtn(8)}
                      >
                        {"|"}
                        <i class="fa fa-bank  ml-3 mr-3 mt-1"></i>{" "}
                        BankDeposit
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="7"
                        onClick={() => setbtn(9)}
                      >
                        {"|"}
                        <i class="fa fa-bank ml-3 mr-3 mt-1"></i> Bank
                        Transfer
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="7"
                        onClick={() => setbtn(10)}
                      >
                        {"|"}
                        <i class="fa fa-credit-card ml-3 mr-3 mt-1"></i> Journal
                        Entry
                      </button>
                    </div>

                    <div style={{ width: "fit-content" }}>
                      <button
                        className="btn btn-sm btn-secondary col d-flex justify-content-end mr-3 mt-3 border-0 p-0 m-0"
                        role="tab"
                        id="7"
                        onClick={() => setbtn(19)}
                      >
                        {"|"}
                        <i style={{fontSize:"16px"}} class="fas fa-infinity ml-3 mr-2 mt-1"></i>  Onfleet
                      </button>
                    </div>
                  </div>
                  <div
                    style={{ width: "fit-content" }}
                    className="col text-center p-lg-medium "
                  >
                    <p className="p-lg">
                      {btn === 1
                        ? "Customer Details"
                        : btn === 2
                        ? "Supplier Details"
                        : btn === 3
                        ? "Item Details"
                        : btn === 4
                        ? "Sale Details"
                        : btn === 5
                        ? " Categories Details"
                        : btn === 6
                        ? "Purchase Order  Details"
                        : btn === 13
                        ? "Receive  Details"
                        : btn === 14
                        ? "Supplier Return  Details"
                        : btn === 15
                        ? " Vendor Credit  Details"
                        : btn === 16
                        ? "Expense  Details"
                        : btn === 7
                        ? "Employee Details"
                        : btn === 8
                        ? "Bank Deposit Details"
                        : btn === 9
                        ? "Bank Transfer Details"
                        : btn === 10
                        ? "Journal Entry Details"
                        : btn === 11
                        ? "Return/Memo Details"
                        : btn === 12
                        ? "Estimate Details"
                        : btn === 17
                        ? "PayBills Details"
                        : btn === 18
                        ? "Receive Payment Details"
                        : ""}
                    </p>
                  </div>
                </Box>
              </>
            )}
          />
        </div>
      </div>
      {/* {label && 
    <span>
     <button>
       Revoke token
     </button>
    </span>
   } */}
    </div>
  );
};

export default QuickbookSync;
